export default (props, vars) => () =>
  vars?.['usestatedownloadpopupopened']?.['setState'](false);
